export default __webpack_public_path__ + "edd2ab215ca49622cd3756442f6cc5ad.svg";